<template>
  <ContainerComponent>
    <section class="content">
      <section class="top-section">
        <section class="product-section-1">
          <HomeProductComponent
            v-for="obj in sortLooper(0, 1)"
            :key="obj.prefix"
            :product="obj"
            :is-short-title-bg="false"
          />
        </section>
        <section class="section-3-wrapper">
          <section class="product-section-3">
            <h3 class="vertical-text">Macro</h3>
            <HomeProductComponent
              v-for="obj in sortLooper(3, 5)"
              :key="obj.prefix"
              :product="obj"
              :is-short-title-bg="false"
            />
            <h3 class="vertical-text">Small cells</h3>
            <HomeProductComponent
              v-for="obj in sortLooper(5, 7)"
              :key="obj.prefix"
              :product="obj"
              :is-short-title-bg="false"
            />
          </section>
          <h3 class="family-header">Radio</h3>
        </section>
        <section class="product-section-2">
          <HomeProductComponent
            v-for="obj in sortLooper(8, 9)"
            :key="obj.prefix"
            :product="obj"
            :is-short-title-bg="false"
          />
          <HomeProductComponent
            v-for="obj in sortLooper(2, 3)"
            :key="obj.prefix"
            :product="obj"
            :is-short-title-bg="false"
          />
          <HomeProductComponent
            v-for="obj in sortLooper(1, 2)"
            :key="obj.prefix"
            :product="obj"
            :is-short-title-bg="false"
          />
        </section>
      </section>
      <section class="bottom-section">
        <HomeProductComponent
          v-for="obj in sortLooper(7, 8)"
          :key="obj.prefix"
          :product="obj"
          :is-short-title-bg="true"
        />
      </section>
    </section>
    <section class="footer">
      <div class="custom-selection-name">
        <i v-if="isCustomSelection" class="icon icon-crown"></i>
        {{ customSelectionName }}
      </div>
      <router-link
        class="btn showcase-btn"
        :to="{ name: 'custom-selection-projects' }"
      >
        Customize
      </router-link>
      <div class="push-right">
        <!-- The button is temporarily hidden because the visualizer is broken -->
        <!-- <a
          class="btn showcase-btn"
          href="https://edcpsso.live.ericsson.net/site-visualizer/"
          target="_blank"
          v-if="isWeb"
        >
          Site Visualizer
        </a> -->
        <!-- <router-link class="btn showcase-btn" :to="{ name: 'showcase' }">
          Ericsson Imagine Studio
        </router-link> -->
        <router-link v-for="page in pages" :key="page.id" v-if="!isMANAVersion()" class="btn showcase-btn" :to="{ path: 'page/' + page.id }">
          {{ page.shortName }}
        </router-link>
        <router-link v-if="!isMANAVersion()" class="btn showcase-btn" :to="{ name: 'mwc' }">
          MWC {{ assetsMwc.year }}
        </router-link>
        <router-link class="btn showcase-btn" :to="{ name: 'silicon' }">
          Ericsson Silicon
        </router-link>
        <router-link class="btn showcase-btn" :to="{ name: 'portfolio' }">
          Ericsson Radio System portfolio
        </router-link>
      </div>
    </section>
  </ContainerComponent>
</template>

<script>
import ContainerComponent from '@/components/ContainerComponent';
import HomeProductComponent from '@/components/HomeProductComponent';
import { mapState } from 'vuex';
import readIsManaVersionFlag from '@/shared/manaVersionHelper';
import axios from 'axios';
import { getStaticUrl } from '@/helpers';
import { SECTIONS } from '@/constants/routes';
import AssetsMwcService from '@/services/assetsMwcServices/assetsMwcService';
import ProductApiService from '@/services/productApiService';
import StaticUrlService from '@/services/staticUrlService';

export default {
  components: {
    ContainerComponent,
    HomeProductComponent
  },
  props: {
    productTreeView: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      assetsMwc: null,
      pages: []
    }
  },
  async created() {
    const fullStaticUrl = await StaticUrlService.getFullStaticUrl(null, this.$route.name);
    axios
      .get(`${fullStaticUrl}familiesView.json?` + Date.now())
      .then(response => this.$localStorage.set('allFamilyPreview', response.data));
    axios
      .get(`${fullStaticUrl}assetsMwc.json?` + Date.now())
      .then(response => {
        this.$localStorage.set('assetsMwc', response.data);
        this.assetsMwc = AssetsMwcService.getAssetsMwc();
      } );
    axios
      .get(`${fullStaticUrl}pages.json?` + Date.now())
      .then(response => {
        this.pages = response.data;
      } );
    await ProductApiService.get();
  },
  computed: {
    isCustomSelection() {
      return this.$store.getters.activeCategories.length;
    },
    isWeb() {
      return !(localStorage.getItem('isElectron') || false);
    },
    staticUrl () {
      return getStaticUrl(null, this.$route.name);
    },
    ...mapState(['customSelectionName'])
  },
  mounted() {
    axios.get(`${this.staticUrl}productData.json?` + Date.now()).then(result => {
      this.$store.commit(
        'radios',
        result.data.filter(x => x.isMana == readIsManaVersionFlag())
      );
      //this.setFamiliesNames(result.data);
    });
  },
  methods: {
    sortLooper(from, to) {
      var arr = [];
      /* Does not include end of array (the "to" value) */
      SECTIONS.slice(from, to).forEach(val => {
        arr.push(val);
      });
      return arr;
    },
    isMANAVersion() {
      return readIsManaVersionFlag();
    },
    setFamiliesNames(products) {
      const families = new Set();
      products.forEach(product => families.add(product.sectionName));
      this.$localStorage.set('productFamilies', Array.from(families).sort());
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

.main {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.footer {
  display: flex;
  background-color: @gray-09;
  height: 46 / @px;
  padding: 9 / @px @space-xl 12 / @px;
  justify-content: flex-start;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  .btn {
    min-width: 60 / @px;
    padding: 6 / @px 12 / @px 5 / @px;
    border-radius: 3 / @px;
    font-size: 12 / @px;
    line-height: 1;
    color: #fff;
    background-color: transparent;
    border: 1 / @px solid #fff;
  }
  .showcase-btn {
    padding: 6 / @px 20 / @px 5 / @px;
  }
  .push-right {
    margin-left: auto;
  }
  .custom-selection-name {
    margin: auto 6 / @px;
    margin-left: 0;
    max-width: @proj-name-max-width;
  }
}

.content {
  display: grid;
  padding: @space-base @space-xl 0 @space-xl;
  background-color: @gray-09;
  flex: 1;
  grid-template-rows: auto 15%;
  padding-bottom: 46 / @px;
  row-gap: @space-base;

  .top-section {
    display: grid;
    width: 100%;
    column-gap: @space-base;
    grid-template-columns: 19% 43% auto;
    .product-section-1 {
      display: grid;
      column-gap: @space-base;
      grid-template-columns: 1fr;
    }
    .product-section-2 {
      display: grid;
      column-gap: @space-base;
      grid-template-columns: 1fr 1fr 1fr;
    }
    .section-2-wrapper {
      display: grid;
      grid-template-rows: auto 1fr;
      .product-section-2 {
        display: grid;
        row-gap: @space-base;
        grid-template-rows: 1fr 1fr 1fr;
      }
    }
    .section-3-wrapper {
      display: grid;
      grid-template-rows: auto 0fr;
      background-color: @gray-05;
      .product-section-3 {
        display: grid;
        grid-gap: @space-small;
        grid-template-columns: (@space-medium + @font-size-xl + @space-medium) 1fr 1fr;
      }
    }
    .vertical-text {
      position: relative;
      bottom: -95%;
      left: @space-medium;
      transform: rotate(-90deg);
      transform-origin: 0% 0%;
      white-space: nowrap;
    }
    .family-header {
      background-color: fade(@gray-05, 90%);
      margin: 0;
      padding: @space-medium;
    }
  }
  .bottom-section {
    display: grid;
    grid-template-rows: auto;
  }
}
</style>
